import SmoothScroll from 'smooth-scroll';
import objectFitImages from 'object-fit-images';
require('cookieconsent');

class Theme {
    constructor(element) {
        this.element = element;
        this.$element = $(element);

        // Settings
        this.slickSettings = {
            rows: 0,
            dots: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            mobileFirst: true,
            responsive: [ {breakpoint: 767, settings: 'unslick' } ]
        };

        // Elements
        this.$carousel = $('.carousel');

        objectFitImages();

        this.initialize();

        // https://cookieconsent.insites.com/documentation/javascript-api/
        this.cookieConsent();
    }

    initialize() {
        this.setTooltips();
        this.scrollToAnchor();
        this.slickCarousel();
    }

    cookieConsent() {
        cookieconsent.initialise({
            content: {
                message: 'En poursuivant votre navigation, vous acceptez l’utilisation de cookies destinés à mesurer l’audience.',
                link: 'Pour en savoir plus',
                href: 'mentions-legales/',
                dismiss: 'Accepter'
            },
            position: 'bottom',
            law: true,
            dismissOnWindowClick: true
        });
    }

    scrollToAnchor() {
        let desktop = (window.matchMedia('(min-width: 992px)').matches);
        let offset = 50;

        if (desktop) {
            offset = 80;
        }

        let scroll = new SmoothScroll('[data-scroll]', {
            offset: offset
        });

        // Anchor in URL
        if ( !window.location.hash || !document.querySelector( window.location.hash ) ) {
            return;
        }

        let anchor = document.querySelector( window.location.hash ); // Get the anchor
        let options = {}; // Any custom options you want to use would go here
        scroll.animateScroll( anchor, anchor, options );
    }

    setTooltips(options) {
        $('[data-toggle="tooltip"]').tooltip(options);
    }

    slickCarousel() {
        this.$carousel.slick(this.slickSettings);
    }
}

export default Theme;



// WEBPACK FOOTER //
// ./resources/scripts/theme.js